const LOG_ATTRIBUTES = {
  id: "modules/analytics/schema/logAttributes",
  type: "object",
  properties: {
    log_type: {
      type: "string",
    },
    log_value: {
      type: "string",
    },
    custom: {
      type: "object",
    },
  },
  required: ["log_type"],
}

export default LOG_ATTRIBUTES
